import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Button, Dialog, DialogTitle, DialogContent, DialogActions,
    TableContainer, Table, TableBody
} from "@material-ui/core";
import CancelAcceptForm from "../../../../Common/CancelAcceptForm";
import ConfirmationDialog from "../../../../Common/ConfirmationDialog";
import t from "../../../../../languages/pl";
import {buttonStyle} from "../buttonGroupStyle";
import {themeTypeToBool} from '../../../../../utils/helpers';
import RentingRow from './RentingRow';
import NoData from './../../../../Common/NoDataRow';
import TableHeader from "../../../../Common/TableHeader";
import DateRow from './DateRow';
import moment from 'moment-timezone';
import guid from './../../../../../utils/guid';
import {displayDateFormat, displayDateTimeFormat} from "../../../../../utils/staticData";
import ReservationDialog from './ReservationDialogComponent/ReservationDialog';

const useStyles = theme => ({
    button: buttonStyle(theme),
    container: {
        maxHeight: "55vh"
    },
    header: {
        background: themeTypeToBool(theme.palette.type) ? "#F0F0F7" : "inherit",
        textAlign: "center"
    }
});

const RentingListHeader = [
    t.dateFrom,
    t.dateTo,
    t.driver,
    t.operator,
    t.meterCountBefore,
    t.meterCountAfter,
    t.distance,
    t.description,
    ""
];

const RentingList = props => {
    const {
        classes,
        name,
        rents,
        dialogOpenCallback,
        carId,
        onDialogOpenCallback,
        onAddPool,
        onAddRent,
        onDateChange
    } = props;
    const [open, setOpen] = useState(false);
    const [openNewRent, setOpenNewRent] = useState(false);
    const [rentType, setRentType] = useState('');
    const [idToDelete, setIdToDelete] = useState(null);
    const [dateType, setDateType] = useState('');
    const [dateValue, setDateValue] = useState('');

    const handleDialogOpenCallback = (rent_id, type) => {
        onDialogOpenCallback(rent_id, type);
    };

    const handlePoolOpen = () => {
        setOpenNewRent(true);
        setRentType('Pool');
    };

    const handleRentOpen = () => {
        setOpenNewRent(true);
        setRentType('Wynajem');
    };

    const handleDateChange = (type, value, rentId) => {
        setIdToDelete(rentId);
        setDateType(type);
        setDateValue(value);
    };

    const handleConfirmationDateChange = () => {
        onDateChange(dateType, dateValue, idToDelete);
    };

    const printTable = (data) => {
        if (!Array.isArray(data) || data.length === 0)
            return <NoData colSpan={9}/>;
        return data.map((row, index) => {

            if (index === 0) {
                return (
                    <DateRow
                        key={guid()}
                        data={row}
                        carId={carId}
                        onDialogOpenCallback={(rent_id, type) => handleDialogOpenCallback(rent_id, type)}
                        onDateChangeCallback={handleDateChange}/>
                );
            }

            if (row.data_od !== undefined) {
                if (moment.unix(data[index - 1].data_od).format(displayDateFormat) !== moment.unix(row.data_od).format(displayDateFormat))
                    return (
                        <DateRow
                            key={guid()}
                            data={row}
                            carId={carId}
                            onDialogOpenCallback={(rent_id, type) => handleDialogOpenCallback(rent_id, type)}
                            onDateChangeCallback={handleDateChange}/>
                    );
            }

            return (
                <RentingRow
                    key={row.wynajem_id}
                    data={row}
                    carId={carId}
                    onDialogOpenCallback={(rent_id, type) => handleDialogOpenCallback(rent_id, type)}
                    onDateChangeCallback={handleDateChange}
                />
            );
        });
    };

    const handleDialogOpen = () => {
        setOpen(true);
        if (dialogOpenCallback)
            dialogOpenCallback();
    };

    const handleOnAddPool = (data) => {
        onAddPool(data);
        setOpenNewRent(false);
    };

    const handleOnAddRent = (data) => {
        onAddRent(data);
        setOpenNewRent(false);
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {t.rentingList}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="xl"
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    {t.rentingList} {name}
                </DialogTitle>
                <DialogContent>
                    <TableContainer>
                        <Table stickyHeader>
                            <TableHeader data={RentingListHeader}/>
                            <TableBody>
                                {printTable(rents)}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={handleRentOpen}
                    >
                        {t.addRent}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={handlePoolOpen}
                    >
                        {t.addPool}
                    </Button>
                    <CancelAcceptForm
                        onSubmit={() => setOpen(false)}
                        onCancel={() => setOpen(false)}/>
                </DialogActions>
            </Dialog>
            <ReservationDialog
                isDialogOpen={openNewRent}
                closeDialog={() => setOpenNewRent(false)}
                rentType={rentType}
                onAddPool={handleOnAddPool}
                onAddRent={handleOnAddRent}
                isEdit={false}
                cars={[]}
            />
            <ConfirmationDialog
                open={idToDelete !== null}
                onClose={() => setIdToDelete(null)}
                onSubmit={handleConfirmationDateChange}
                id={idToDelete}
                action={t.changeDate}
                additionalText={t.newDate + moment.unix(dateValue).format(displayDateTimeFormat)}
            />
        </React.Fragment>
    );
};


RentingList.propTypes = {
    classes: PropTypes.object,
    name: PropTypes.string,
    rents: PropTypes.array,
    dialogOpenCallback: PropTypes.func,
    onDialogOpenCallback: PropTypes.func,
    carId: PropTypes.number,
    onAddPool: PropTypes.func,
    onAddRent: PropTypes.func,
    onDateChange: PropTypes.func,
};

export default withStyles(useStyles)(RentingList);